import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxEchartsModule } from 'ngx-echarts';
import { AngularDraggableModule } from 'angular2-draggable';
import { AngularResizedEventModule } from 'angular-resize-event';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NbThemeModule, 
  NbLayoutModule, 
  NbCardModule, 
  NbInputModule,
  NbSelectModule,  
  NbCheckboxModule,
  NbButtonModule, 
  NbStepperModule, 
  NbRadioModule, 
  NbDatepickerModule, 
  NbCalendarModule, 
  NbIconModule, 
  NbToastrModule,
  NbTreeGridModule, NbTabsetModule, NbToggleModule } from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { AppRoutingModule } from './app-routing.module';

import { SelectComponent } from './select/select.component';
import { InputComponent } from './input/input.component';
import { CardComponent } from './card/card.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { RadioComponent } from './radio/radio.component';
import { SliderComponent } from './slider/slider.component';
import { ButtonComponent } from './button/button.component';
import { StepperComponent } from './stepper/stepper.component';
// import { StepComponent } from './stepper/step.component';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkStepperModule } from '@angular/cdk/stepper';
// import { TableComponent } from './table/table.component';
import { DatePickerComponent } from './datepicker/datepicker.component';
import { BarEchartComponent } from './charts/barchart/barchart.component';
import { TableService } from './table/table.service';
// import { CanvasComponent } from './canvas/canvas.component';
import { PieEchartsComponent } from './charts/piechart/piechart.component';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { RadarEchartsComponent } from './charts/radar/radar.component';
import { StackEchartComponent } from './charts/stackchart/stackchart.component';
import { WaterfallEchartComponent } from './charts/waterfall/waterfall.component';
import { LineEchartComponent } from './charts/linechart/linechart.component';
import { SankeyEchartComponent } from './charts/sankey/sankey.component';
import { MapComponent } from './charts/map/map.component';
import { FileUploadComponent } from './file-uploader/file-upload.component';
import { TreeTableComponent } from './tree-table/tree-table.component'
import { CHART_CONFIG} from './charts/config/baseconfig.component';
import { TreeTableService } from './tree-table/tree-table.service';
import { TabsComponent } from './tabs/tabs.component';
import { ToggleComponent } from './toggle/toggle.component';
import { MapService } from './charts/map/map.service';

// import { NumberPipePipe } from './slider/number.pipe';

@NgModule({
  declarations: [
    AppComponent,
    // CanvasComponent,
    InputComponent,
    ButtonComponent,
    CardComponent,
    SelectComponent,
    CheckboxComponent,
    RadioComponent,
    SliderComponent,
    StepperComponent,
    // StepComponent,
    TabsComponent,
    ToggleComponent,
    // TableComponent,
    DatePickerComponent,
    BarEchartComponent,
    RadarEchartsComponent,
    PieEchartsComponent,
    StackEchartComponent,
    WaterfallEchartComponent,
    LineEchartComponent,
    SankeyEchartComponent,
    MapComponent,
    FileUploadComponent,
    TreeTableComponent,
    // NumberPipePipe,
    CHART_CONFIG
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    FormsModule,
    NgxChartsModule,
    NgxEchartsModule,
    NbThemeModule.forRoot({ name: 'default' }),
    NbDatepickerModule.forRoot(),
    NbCalendarModule,
    NbToastrModule.forRoot(),
    NbTabsetModule,
    NbLayoutModule,
    NbIconModule,
    NbToggleModule,
    NbEvaIconsModule,
    NbButtonModule,
    NbInputModule,
    NbSelectModule,
    NbCardModule,
    NbStepperModule,
    NbCheckboxModule,
    NbRadioModule,
    CdkTableModule,
    CdkStepperModule,
    NbTreeGridModule,
    AngularDraggableModule,
    AngularResizedEventModule,
    AppRoutingModule
  ],
  providers: [ {provide: APP_BASE_HREF, useValue: '/'}, TableService, TreeTableService, MapService],
  entryComponents: [
    AppComponent,
    // CanvasComponent,
    InputComponent,
    ButtonComponent,
    CardComponent,
    SelectComponent,
    CheckboxComponent,
    RadioComponent,
    SliderComponent,
    StepperComponent,
    // StepComponent,
    TabsComponent,
    ToggleComponent,
    // TableComponent,
    TreeTableComponent,
    DatePickerComponent,
    BarEchartComponent,
    RadarEchartsComponent,
    PieEchartsComponent,
    StackEchartComponent,
    LineEchartComponent,
    SankeyEchartComponent,
    MapComponent,
    WaterfallEchartComponent,
    FileUploadComponent,
  ],
  // bootstrap: [AppComponent,]
  
})
export class AppModule { 

  constructor(private injector: Injector) {}

  ngDoBootstrap() {

    //APP COMPONENT DECLARATION
    const appEl = createCustomElement(AppComponent, {injector: this.injector});
    customElements.define('nbxr-app', appEl);

    // //CANVAS COMPONENT DECLARATION
    // const canvasEl = createCustomElement(CanvasComponent, {injector: this.injector});
    // customElements.define('nbxr-canvas', canvasEl);

    //INPUT COMPONENT DECLARATION
    const inputEl = createCustomElement(InputComponent, {injector: this.injector});
    customElements.define('nbxr-input', inputEl);

    //BUTTON COMPONENT DECLARATION
    const buttonEl = createCustomElement(ButtonComponent, {injector: this.injector});
    customElements.define('nbxr-button', buttonEl);

    //CARD COMPONENT DECLARATION
    const cardEl = createCustomElement(CardComponent, {injector: this.injector});
    customElements.define('nbxr-card', cardEl);

    //SELECT COMPONENT DECLARATION
    const selectEl = createCustomElement(SelectComponent, {injector: this.injector});
    customElements.define('nbxr-select', selectEl);

    //CHECKBOX COMPONENT DECLARATION
    const checkboxEl = createCustomElement(CheckboxComponent, {injector: this.injector});
    customElements.define('nbxr-checkbox', checkboxEl);

    //RADIO COMPONENT DECLARATION
    const radioEl = createCustomElement(RadioComponent, {injector: this.injector});
    customElements.define('nbxr-radio', radioEl);

    //SLIDER COMPONENT DECLARATION
    const sliderEl = createCustomElement(SliderComponent, {injector: this.injector});
    customElements.define('nbxr-slider', sliderEl);

    //STEPPER COMPONENT DECLARATION
    const stepperEl = createCustomElement(StepperComponent, {injector: this.injector});
    customElements.define('nbxr-stepper', stepperEl);

    //STEPCOMPONENT DECLARATION
    // const stepEl = createCustomElement(StepComponent, {injector: this.injector});
    // customElements.define('nbxr-step', stepEl);

    //TABCOMPONENT DECLARATION
    const tabsEl = createCustomElement(TabsComponent, {injector: this.injector});
    customElements.define('nbxr-tabs', tabsEl);

    //TABLE COMPONENT DECLARATION
    const treeTableEl = createCustomElement(TreeTableComponent, {injector: this.injector});
    customElements.define('nbxr-tree-table', treeTableEl);

    //TABLE COMPONENT DECLARATION
    const toggleEl = createCustomElement(ToggleComponent, {injector: this.injector});
    customElements.define('nbxr-toggle', toggleEl);

    //DATEPICKER COMPONENT DECLARATION
    const datepickerEl = createCustomElement(DatePickerComponent, {injector: this.injector});
    customElements.define('nbxr-datepicker', datepickerEl);

    //BARCHART COMPONENT DECLARATION
    const barchartEl = createCustomElement(BarEchartComponent, {injector: this.injector});
    customElements.define('nbxr-barchart', barchartEl);

    //RADAR CHART COMPONENT DECLARATION
    const echartradarEl = createCustomElement(RadarEchartsComponent, {injector: this.injector});
    customElements.define('nbxr-radarchart', echartradarEl);

    // PIE CHART COMPONENT DECLARATION
    const echartpieEl = createCustomElement(PieEchartsComponent, {injector: this.injector});
    customElements.define('nbxr-piechart', echartpieEl);

    // STACK CHART COMPONENT DECLARATION
    // const echartstackEl = createCustomElement(StackEchartComponent, {injector: this.injector});
    // customElements.define('nbxr-stackchart', echartstackEl);

    // LINE CHART COMPONENT DECLARATION
    const echartlineEl = createCustomElement(LineEchartComponent, {injector: this.injector});
    customElements.define('nbxr-linechart', echartlineEl);

    // SANKEY CHART COMPONENT DECLARATION
    const echartsankeyEl = createCustomElement(SankeyEchartComponent, {injector: this.injector});
    customElements.define('nbxr-sankeychart', echartsankeyEl);

    // MAP CHART COMPONENT DECLARATION
    const echartmapEl = createCustomElement(MapComponent, {injector: this.injector});
    customElements.define('nbxr-map', echartmapEl);

    // FILEUPLOADER COMPONENT DECLARATION
    const fileuploaderEl = createCustomElement(FileUploadComponent, {injector: this.injector});
    customElements.define('nbxr-fileupload', fileuploaderEl);
  }

}
